// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .menu-item {
    background-color: #2C303B;
} */

img.menu-icon-img {
  width: 22px;
  padding-right: 5px;
}

.menu-item,
.menu-title {
  font-size: 12px;
}

#main-menu li a {
  display: flex;
  align-items: center;
  gap: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/app/_layout/navigation/verticalnav/verticalnav.component.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":["/* .menu-item {\n    background-color: #2C303B;\n} */\n\nimg.menu-icon-img {\n  width: 22px;\n  padding-right: 5px;\n}\n\n.menu-item,\n.menu-title {\n  font-size: 12px;\n}\n\n#main-menu li a {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
